import React, { useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import PageHttp from '~/commons/components/PageHttp.jsx';
import Html from '~/commons/components/Html.jsx';
import useHttpStatus from '~/commons/hooks/useHttpStatus';

const PageCookiePolicy = () => {
  const [res, req] = useHttpStatus();
  useEffect(() => {
    req({ url: '/api/site/terms?filter[key]=pp' });
  }, []);
  const history = useHistory();

  return (
    <PageHttp res={res}>
      {(doc) => (
        <div className="container">
          <button
            onClick={() => history.goBack()}
            className="btn btn-primary btn-sm mb-4"
          >
            Back
          </button>
          <Html>
            {doc?.rows?.[0]?.content?.en || 'No active Privacy Policy'}
          </Html>
        </div>
      )}
    </PageHttp>
  );
};

export default PageCookiePolicy;
